<template>
    <div class="margin-config-card">
        <div class="margin-header-row">
            <input-search class="margin-action-search" @getData="getSearch" />
            <div class="margin-actions-row">
                <div class="position-relative d-inline-flex">
                    <select
                        v-model="selectedConfigStatus"
                        class="btn btn-sm bg-white fw-400 select-like-btn"
                        @change="onConfigStatusChange"
                        style="padding:0 44px;min-width:180px;text-align:center;color:black!important;border:1px solid black!important"
                    >
                        <option value="">Todos</option>
                        <option value="normal">Normal</option>
                        <option value="por_configurar">Por configurar</option>
                        <option value="fuera_de_rango">Fuera de rango</option>
                        <option value="por_encima">Por encima</option>
                        <option value="por_debajo">Por debajo</option>
                    </select>
                    <img src="/icons/filter-recomendation.svg" alt="filter" class="icons-dark" style="position:absolute;left:10px;top:50%;transform:translateY(-50%);pointer-events:none" />
                </div>
                <button 
                    class="btn btn-sm bg-white fw-400"
                    style="
                        color: black !important;  
                        border: 1px solid black !important
                    "
                    @click="viewConfig('','config-margin-options','Configuración','Establece los rangos mínimos y máximos para varios productos de manera simultánea')"
                >
                    Configuración en lote
                </button>
                <button 
                    class="btn fw-500 button-export text-white rounder-8 button-products d-flex align-items-center"
                    @click="exportDataFile"
                >
                    <img src="/icons/down.svg" alt="icono" class="me-1 icons">Exportar
                </button>
            </div>
        </div>

        <div class="margin-table-info-row">
            <span 
                class="margin-total-count"
                v-if="totalCount > 0 && !loading"
            >
                Total: {{ totalCount }}
            </span>
        </div>
        <div class="table-responsive border" v-if="products.length > 0 || loading">
            <placeholder v-if="loading" :type="'table'" :count="3"/>
            <table class="margin-table w-100" v-else>
                <thead>
                    <tr>
                        <th v-if="isColumnVisible('sku')">{{ getColumnLabel('sku') }}</th>
                        <th v-if="isColumnVisible('long_name')">{{ getColumnLabel('long_name') }}</th>
                        <th
                            v-if="isColumnVisible('store_name')"
                            class="margin-nowrap"
                        >
                            {{ getColumnLabel('store_name') }}
                        </th>
                        <th v-if="isColumnVisible('cost_price')" class="margin-nowrap">{{ getColumnLabel('cost_price') }}</th>
                        <th v-if="isColumnVisible('unit_price')" class="margin-nowrap">{{ getColumnLabel('unit_price') }}</th>
                        <th v-if="isColumnVisible('unit_sale')" class="margin-nowrap">{{ getColumnLabel('unit_sale') }}</th>
                        <th v-if="isColumnVisible('margin_percent_list')" class="margin-nowrap">{{ getColumnLabel('margin_percent_list') }}</th>
                        <th v-if="isColumnVisible('margin_percent')" class="margin-nowrap">{{ getColumnLabel('margin_percent') }}</th>
                        <th 
                            v-if="isColumnVisible('food_cost')"
                            class="margin-nowrap"
                        >
                            {{ getColumnLabel('food_cost') }}
                        </th>
                        <th v-if="isColumnVisible('margin_min')" class="margin-nowrap editable-header">{{ getColumnLabel('margin_min') }}</th>
                        <th v-if="isColumnVisible('margin_objective')" class="margin-nowrap editable-header">{{ getColumnLabel('margin_objective') }}</th>
                        <th v-if="isColumnVisible('margin_max')" class="margin-nowrap editable-header">{{ getColumnLabel('margin_max') }}</th>
                        <th v-if="isColumnVisible('margin_config_status')">{{ getColumnLabel('margin_config_status') }}</th>
                        <th v-if="isColumnVisible('margin_config_updated_at')">{{ getColumnLabel('margin_config_updated_at') }}</th>
                        <th v-if="isColumnVisible('actions')">{{ getColumnLabel('actions') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="(product, index) in products" :key="index"
                    >
                        <td v-if="isColumnVisible('sku')">
                            <span class="margin-sku-badge">{{ product.sku }}</span>
                        </td>
                        <td v-if="isColumnVisible('long_name')">{{ product.long_name }}</td>
                        <td
                            v-if="isColumnVisible('store_name')"
                        >
                            {{ product.store_name }}
                        </td>
                        <td v-if="isColumnVisible('cost_price')" class="margin-nowrap">{{authentication_user.client_money}} {{ formatDecimal(product.cost_price) }}</td>
                        <td v-if="isColumnVisible('unit_price')" class="margin-nowrap">{{authentication_user.client_money}} {{ formatDecimal(product.unit_price) }}</td>
                        <td v-if="isColumnVisible('unit_sale')" class="margin-nowrap">{{authentication_user.client_money}} {{ formatDecimal(product.unit_sale) }}</td>
                        <td v-if="isColumnVisible('margin_percent_list')" class="margin-nowrap">
                            <span>
                                {{ product.margin_percent_list }}%
                            </span>
                        </td>
                        <td v-if="isColumnVisible('margin_percent')" class="margin-nowrap">
                            <span :class="getMarginClass(product)">
                                {{ product.margin_percent }}%
                            </span>
                        </td>
                        <td 
                            v-if="isColumnVisible('food_cost')"
                            class="margin-nowrap"
                        >
                            <span :class="getMarginClass(product)">
                                {{ product.food_cost }}%
                            </span>
                        </td>
                        <td v-if="isColumnVisible('margin_min')" class="margin-nowrap col-highlight">
                            <span class="margin-global-value ">{{ formatNumber(product.margin_min) }}</span>
                        </td>
                        <td v-if="isColumnVisible('margin_objective')" class="margin-nowrap col-highlight">
                            <span class="margin-global-value">{{ formatNumber(product.margin_objective) }}</span>
                        </td>
                        <td v-if="isColumnVisible('margin_max')" class="margin-nowrap col-highlight">
                            <span class="margin-global-value">{{ formatNumber(product.margin_max) }}</span>
                        </td>
                        <td v-if="isColumnVisible('margin_config_status')">
                            <span :class="getPositionBadge(product).cls">
                                {{ getPositionBadge(product).label }}
                            </span>
                        </td>
                        <td v-if="isColumnVisible('margin_config_updated_at')">
                            <span class="size-13 text-secondary">{{ formatDateTime(product.margin_config_updated_at) }}</span>
                        </td>
                        <td v-if="isColumnVisible('actions')">
                            <div class="d-flex flex-column gap-1">
                                <span
                                    @click="viewConfig(product,'config-margin-one','Configuración','Establece los rangos mínimos y máximos para el producto seleccionado')"
                                >
                                    <img class="cursor-pointer" src="/icons/pencil-margin.svg" alt="Editar"/>
                                </span>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- No data message -->
        <div v-if="products.length <= 0 && !loading" class="p-4 bg-white rounder-8 border border-1 text-center">
            <h4 class="fw-400 size-18 text-secondary">No existe información para mostrar</h4>
        </div>

        <PaginationControls
            v-if="totalCount > 0"
            :current-page="currentPage"
            :total-count="totalCount"
            :page-size="pageSize"
            @change-page="$emit('change-page', $event)"
            @change-page-size="$emit('change-page-size', $event)"
        />
    </div>
</template>

<script>
import { mapGetters,mapActions} from 'vuex'
import inputSearch from '@/components/inputSearch.vue';
import Placeholder from "../../../../../components/loadings/placeholder.vue";
import PaginationControls from "../../../../../components/PaginationControls.vue";
import {  shouldShowAsRecommender } from '../../../../../utils/servicesValidation.js'
import configsRecTableMixin from '../mixins/configsRecTableMixin.js'
export default {
    name: 'table-margin-config',
    mixins: [configsRecTableMixin],
    components: {
        inputSearch,
        Placeholder,
        PaginationControls
    },
    props:{
        products: {
            type: Array,
            required: true,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: false
        },
        totalCount: {
            type: Number,
            default: 0
        },
        currentPage: {
            type: Number,
            default: 1
        },
        pageSize: {
            type: Number,
            default: 25
        },
        activeServiceId: {
            type: Number,
            default: 5
        }
    },
    data(){
        return {
            search_product: '',
            search_type: 'codigo',
            selectedConfigStatus: "",
            tableConfigKey: 'margin'
        }
    },
    computed: {
        ...mapGetters([
            "authentication_user",
            "activeDesk"
        ]),
        tableWrapperClass() {
            return {
                'table-wrapper-fixed': true,
                'table-wrapper-expanded': !this.activeDesk,
                'table-wrapper-with-sidebar': this.activeDesk
            }
        }
    },
    methods: {
        ...mapActions(["executeCommit","get"]),
        getSearch(row){
            this.search_product = row.search
            this.search_type = row.searchType
            this.$emit('getData', 
                this.search_product,
                this.search_type
            )
        },
        onConfigStatusChange() {
            this.$emit('filterConfigStatus', this.selectedConfigStatus);
        },
        /**
         * Formats a number as a percentage with two decimal places.
         * @param {number} row - The number to format.
         * @returns {string} - The formatted percentage string (e.g., "50.00%").
         */
        formatNumber(row) {
            const parsedValue = Number(row);

            if (row === null || row === undefined || row === '' || Number.isNaN(parsedValue) || parsedValue === 0) {
                return '-';
            }

            return (parsedValue * 100).toFixed(2) + "%";
        },
        formatDecimal(value) {
            if (value == null || value === "") return "0.00";
            if (isNaN(value)) return "0.00";
            return new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value));
        },
        formatDateTime(value) {
            if (!value) return "—";
            let d;
            if (/^\d{2}-\d{2}-\d{4}/.test(value)) {
                const [day, month, year] = value.split("-");
                d = new Date(`${year}-${month}-${day}T00:00:00`);
            } else {
                d = new Date(value);
            }
            if (isNaN(d.getTime())) return value;
            const day = String(d.getDate()).padStart(2, "0");
            const month = String(d.getMonth() + 1).padStart(2, "0");
            const yearFinal = d.getFullYear();
            return `${day}-${month}-${yearFinal}`;
        },
        formatPorcen(cost, price) {
            const iva_price = this.authentication_user.iva_price;
            const iva_cost = this.authentication_user.iva_cost;
            const result = 100 * ((price * iva_price) - (cost * iva_cost)) / (price * iva_price);
            return `${new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(result)}%`;
        },

        parseMarginPercent(value) {
            return parseFloat(value) || 0;
        },
        getMarginState(product) {
            const currentMargin = this.parseMarginPercent(product.margin_percent);
            const minMargin = Number(product.margin_min ?? 0) * 100;
            const maxMargin = Number(product.margin_max ?? 0) * 100;

            if (currentMargin < minMargin) {
                return 'below';
            }

            if (currentMargin > maxMargin) {
                return 'above';
            }

            return 'within';
        },
        getMarginClass(product) {
            const state = this.getMarginState(product);

            return {
                'margin-current-ok': state === 'within',
                'margin-current-bajo': state === 'below',
                'margin-current-alto': state === 'above',
            };
        },
        getMarginStatusBadgeClass(product) {
            const status = product?.margin_status;

            return {
                'margin-status-badge': true,
                'margin-status-ok': status === 'ok',
                'margin-status-bajo': status === 'bajo',
                'margin-status-alto': status === 'alto',
                'margin-status-default': !['ok', 'bajo', 'alto'].includes(status),
            };
        },
        getMarginStatusText(product) {
            const status = product?.margin_status;

            if (status === 'ok') return 'Normal';
            if (status === 'bajo') return 'Fuera de rango';
            if (status === 'alto') return 'Fuera de rango';
            if (status === 'sin configuración') return 'Sin configurar';

            return status || 'N/A';
        },
        getConfigStatusBadgeClass(status) {
            return {
                'margin-status-badge': true,
                'margin-status-ok': status === 'normal',
                'margin-status-bajo': status === 'fuera_de_rango',
                'margin-status-default': !status || status === 'por_configurar',
            };
        },
        getConfigStatusLabel(status) {
            if (status === 'normal') return 'Normal';
            if (status === 'fuera_de_rango') return 'Fuera de rango';
            if (status === 'por_configurar') return 'Por configurar';
            return status || '—';
        },
        /**
         * Badge for the status column, driven by the backend-computed
         * margin_status (classify_margin). Falls back to the stored
         * margin_config_status when margin_status is missing or 'error'.
         */
        getPositionBadge(product) {
            const status = product?.margin_status;

            if (status === 'bajo') {
                return { label: 'Por debajo', cls: { 'margin-status-badge': true, 'margin-status-bajo': true } };
            }
            if (status === 'alto') {
                return { label: 'Por encima', cls: { 'margin-status-badge': true, 'margin-status-alto': true } };
            }
            if (status === 'ok') {
                return { label: 'Normal', cls: { 'margin-status-badge': true, 'margin-status-ok': true } };
            }
            if (status === 'sin configuración') {
                return { label: 'Por configurar', cls: { 'margin-status-badge': true, 'margin-status-default': true } };
            }

            return {
                label: this.getConfigStatusLabel(product.margin_config_status),
                cls: this.getConfigStatusBadgeClass(product.margin_config_status),
            };
        },
        viewConfig(row,name,title,text){
            this.$emit('viewModal', row, name, title, text);
        },
    /**
      * Exports filtered product data as an Excel file.
      */
        exportDataFile() {
        this.executeCommit({ mutation: "loading_state_component" });
            let url = `/api/products/export_config_margin/?service_id=${this.activeServiceId}`;
        if (!this.authentication_user.client_channel){
            url = url + `&business=${this.authentication_user.client_business_select}`
        }
        this.get({
            url: url,
        }).then(() => {
            this.executeCommit({ mutation: "loading_state_component" });
            this.$notification.success(
            "En un momento te llegará un correo electrónico con los datos del maestro de productos",
            { timer: 10, showCloseIcn: true }
            );
        });
        },
        /**
         * Verifica si debe mostrar como recomendador (para usar en template)
         */
        shouldShowAsRecommender(user = null) {
            return shouldShowAsRecommender(user || this.authentication_user, this.activeServiceId);
        }
    }
}
</script>

<style scoped>
.margin-config-card {
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 24px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* ===== Header: búsqueda + acciones ===== */
.margin-header-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 1.25rem;
}

/* Grupo de acciones: alineado a la derecha, NO crece más de lo necesario */
.margin-actions-row {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.5rem;
    flex-wrap: wrap;
    flex: 0 1 auto;
    max-width: 100%;
}

.margin-actions-row .btn {
    height: 44.8px;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;
}

.margin-actions-row select {
    height: 44.8px;
}

.margin-actions-row select:hover {
    background-color: #f8f9fa !important;
    color: #212529 !important;
}


/* Compatibilidad: evitar mostrar flecha nativa en Firefox */
select.select-like-btn::-ms-expand { display: none; }

.margin-table-info-row {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 0.5rem;
    margin-top: 0.25rem;
}

.margin-total-count {
    font-size: 0.85rem;
    font-weight: 600;
    color: #6b7280;
    white-space: nowrap;
}

/* input-search: shrink/grow con un ancho mínimo */
.margin-action-search {
    flex: 1 1 250px;
    min-width: 0;
}

.margin-action-search :deep(.search-container-wrapper),
.margin-action-search ::v-deep .search-container-wrapper,
.margin-action-search /deep/ .search-container-wrapper {
    width: 100%;
    max-width: none;
}

.margin-action-search ::v-deep .search-wrapper,
.margin-action-search /deep/ .search-wrapper {
    width: 100%;
}

/* Breakpoint: acciones en grid 2x2 cuando no hay espacio */
@media (max-width: 991.98px) {
    .margin-actions-row {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 0.5rem;
        width: 100%;
        align-items: stretch;
    }

    .margin-actions-row > * {
        box-sizing: border-box;
        min-width: 0;
        width: 100%;
    }

    .margin-actions-row .btn,
    .margin-actions-row select {
        width: 100%;
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }
}

@media (max-width: 575.98px) {
    .margin-actions-row {
        grid-template-columns: repeat(2, 1fr);
        gap: 0.4rem;
    }
}

.search-form /deep/ {
    width: auto;
    flex: 1 1 auto;
    min-width: 0;
}


.search-container /deep/ {
    min-width: 0;
}

.form-control-search /deep/{
    min-width: 0;
}

.search-wrapper .form-select /deep/ {
    width: 86px;
    flex: 0 0 86px;
}

/* Tabla */
.margin-table {
    border-collapse: collapse;
    font-size: 0.85rem;
}

.margin-table thead th {
    text-align: left;
    font-size: 0.7rem;
    font-weight: 700;
    color: #9ca3af;
    letter-spacing: 0.03em;
    padding: 10px 12px;
    border-bottom: 1px solid #e5e7eb;
    white-space: nowrap;
    background-color: #F3F4F6;
}

.margin-table tbody td {
    padding: 12px;
    border-bottom: 1px solid #f3f4f6;
    vertical-align: middle;
    color: #1f2937;
}

.margin-table .margin-nowrap {
    white-space: nowrap;
}

.margin-table tbody tr:hover {
    background: #fafafa;
}

.margin-sku-badge {
    display: inline-block;
    background: #f3f4f6;
    color: #374151;
    font-size: 0.78rem;
    font-weight: 600;
    padding: 3px 8px;
    border-radius: 6px;
}

.margin-global-value {
    font-size: 0.85rem;
}

.margin-status-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 72px;
    padding: 4px 10px;
    border-radius: 999px;
    font-size: 0.78rem;
    font-weight: 700;
    line-height: 1;
    border: 1px solid transparent;
}

.margin-status-ok {
    background: #ecfdf3;
    color: #027a48;
    border-color: #abefc6;
}

.margin-status-bajo {
    background: #fef3f2;
    color: #b42318;
    border-color: #fecdca;
}

.margin-status-alto {
    background: #fffaeb;
    color: #b54708;
    border-color: #fedf89;
}

.margin-status-default {
    background: #f9fafb;
    color: #6b7280;
    border-color: #e5e7eb;
}

.margin-table thead th.editable-header {
    background-color: #E8F8F4;
    color: #087F6A;
    font-weight: 700;
}

.margin-table tbody td.col-highlight {
    background-color: #F8FCFB;
}

.button-export {
    background-color: #021418;
}

.button-products {
    padding: 10.5px 20px !important;
}

.icons {
    filter: brightness(0) invert(1);
    width: 20px;
    height: 20px;
}

.icons-dark {
    filter: brightness(0);
    width: 18px;
    height: 18px;
}
</style>
